import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
import { useEffect } from 'react';
export const useSidecarPreQuery = ({ setInput }) => {
    const params = useSearchParams();
    useEffect(() => {
        if (!params || !import.meta.env.VITE_IS_SIDECAR_BUILD)
            return;
        const preQueryInput = params.get('p_q');
        if (!preQueryInput)
            return;
        setInput(preQueryInput);
    }, [params, setInput]);
};
//# sourceMappingURL=useSidecarPreQuery.js.map